import { render, staticRenderFns } from "./comment-summary.vue?vue&type=template&id=1bd434a2&scoped=true&"
import script from "./comment-summary.vue?vue&type=script&lang=js&"
export * from "./comment-summary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bd434a2",
  null
  
)

export default component.exports